import { FunctionComponent } from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { StarjackTable } from '@/components/Table/v2/Table';
import { usePagination } from '@starjack/shared-components';
import { Production } from '@/models/production';
import { useGetProductionsQuery } from '@/api/v2/production';

export const ProductionContent: FunctionComponent = () => {
    const { data, isLoading } = useGetProductionsQuery();
    const { currentItems, page, setNextPage, setItemsPerPage, itemsPerPage } =
        usePagination({
            items: data,
        });
    const theme = useTheme();

    return (
        <>
            <Typography sx={{ mb: 8 }} variant='h4'>
                Statistik Produktion
            </Typography>
            <Stack alignItems='flex-start' spacing={theme.page.verticalSpacing}>
                <StarjackTable<Production>
                    count={data?.length}
                    items={currentItems}
                    columns={[
                        {
                            label: 'Kartentyp',
                            itemKey: 'name',
                        },
                        {
                            label: 'Anzahl',
                            itemKey: 'count',
                            options: {
                                rowCellProps: {
                                    align: 'right',
                                },
                            },
                        },
                    ]}
                    currentPage={page}
                    onPageChange={(nextPage) => setNextPage(nextPage)}
                    onRowsPerPageChange={setItemsPerPage}
                    rowsPerPage={itemsPerPage}
                    loading={isLoading}
                    itemId={'name'}
                />
            </Stack>
        </>
    );
};
